import { Button, Card, Form, message, Select, Spin } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/AssetStockTakingSubList";
import MasterModal from "../../components/MasterModal";
import InlineCreateMasterModal from "../../components/InlineCreateMasterModal";
import './style.css';
import SubListForm from "../../components/AssetStockTakingSubListForm";
import { geolocated } from "react-geolocated";
import Popconfirm from "antd/es/popconfirm";
import QrScan from "../../components/QrReader/QRScan";

let cnt = 0, payload = {};

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.qrCode = React.createRef();
    this.state = {
      loading: false,
      showQRCodeSection: 0,
      openCamera: false,
      subData: [{}],
      formData: {},
      disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation: false,
      disableQRCode: false,
      isOldQr: false,
      scannedOrManualAsset: null,
      scannedOrManualQrId: '',
      isQrMatched: {},
      linkRecordCode: null,
      createdAuditVouchers: [],
    };
  }

  componentDidMount = async () => {
    await this.props.onCheck(payload);
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }

    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.roles.length > 0) {
      for (const role of user.roles) {
        if (role && role.disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation) {
          this.setState({
            disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation: true,
          });
          break;
        }
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({ subData: nextProps.data.assetDetails });
    }
    // console.log(nextProps.linkRecord)
    if (nextProps && nextProps.linkRecord && nextProps.linkRecord.linkData && JSON.stringify(nextProps.linkRecord) !== JSON.stringify(this.props.linkRecord)) {

      const { _id, asset, code } = nextProps.linkRecord.linkData;
      // console.log(code)
      this.props.form.setFieldsValue({
        [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][link_record]`]: code || ''
      });
      this.setState({
        linkRecordCode: code
      })
    }

    if (nextProps && nextProps.assetFromQr && nextProps.assetFromQr.data && JSON.stringify(nextProps.assetFromQr) !== JSON.stringify(this.props.assetFromQr)) {

      const { assetCode, scannerData } = nextProps.assetFromQr.data;
      let qr = '';
      const qrData = (scannerData || []).filter(scanner => scanner.type === 'QR')
      if (qrData && qrData.length)
        qr = qrData[qrData.length - 1]['id'];
      this.setState({
        scannedOrManualAsset: nextProps.assetFromQr,
        scannedOrManualQrId: qr,
        subData: [{ assetCode: assetCode || '' }],
        loading: false,
        openCamera: false
      }, () => {
        this.props.form.setFieldsValue({
          [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: assetCode || '',
          [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}]['qrId']`]: qr
        });
      });
    }

    if (nextProps && nextProps.assetFromQr && nextProps.assetFromQr.data === '' && JSON.stringify(nextProps.assetFromQr) !== JSON.stringify(this.props.assetFromQr)) {
      // console.log(nextProps.assetFromQr, this.props.assetFromQr);
      this.setState({
        scannedOrManualAsset: null,
        scannedOrManualQrId: '',
        subData: [{}],
        loading: false,
        openCamera: false
      }, () => {
        this.props.form.setFieldsValue({
          [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: '',
          [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}]['qrId']`]: ''
        });
      });
      message.error(`Invalid QR Id OR No asset found against the QR`)
    }

    if (nextProps && nextProps.match && nextProps.match.params && JSON.stringify(nextProps.match.params.id) !== JSON.stringify(this.props.match.params.id)) {
      nextProps && nextProps.fetch && nextProps.fetch(nextProps.match.params.id);
      // console.log(nextProps.match.params.id)
    }
  }

  setOldQr = (isOldQr) => {
    this.setState({
      isOldQr
    })
  }

  onClick = () => {
    this.child.current.clearDocumentData();
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      const data = Object.assign({}, values);
      const { coords } = this.props;
      data['status'] = 'OPEN';
      if (!values.client) {
        delete data.client;
      }
      data['latitude'] = (coords && coords.latitude) || 0;
      data['longitude'] = (coords && coords.longitude) || 0;
      // console.log(data);
      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id, true);
      } else {
        this.props.onSubmit(data, true);
      }
      this.props.form.resetFields('assetDetails');
      this.child.current.clearDocumentData();
      this.setOldQr(false);
      this.reset();
    });
  };

  reset = () => {
    this.setState({
      scannedOrManualAsset: null,
      scannedOrManualQrId: '',
      subData: [{}],
      loading: false,
      openCamera: false
    })
  };

  handleDone = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      const data = Object.assign({}, values);
      const { coords } = this.props;
      data['status'] = 'OPEN';
      if (!values.client) {
        delete data.client;
      }
      data['latitude'] = (coords && coords.latitude) || 0;
      data['longitude'] = (coords && coords.longitude) || 0;
      // console.log(data);
      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id, false);
      } else {
        this.props.onSubmit(data, false);
      }
      this.setOldQr(false);
      this.reset();
    });
  };

  handleScan = async data => {
    // console.log(`Received QR scanned data - ${data}`)
    if (data && this.state.isOldQr) {
      const assetCode = data;
      // let {subData} = this.state;
      // subData = [{assetCode: assetCode}];
      this.setState({ subData: [{ assetCode: assetCode }], loading: false, openCamera: false }, () => {
        this.props.form.setFieldsValue({ [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: assetCode });
      });
    }
  };

  editEarlier = (id) => {
    this.props.viewEarlier(id);
  }

  selectedLocation = (e) => {
    cnt++;
    if (cnt >= 2) {
      this.sendValues();
    }
  }

  selectedSubLocation = (e) => {
    cnt++;
    if (cnt >= 2) {
      this.sendValues();
    }
  }

  sendValues = async () => {
    payload.location = this.props.form.getFieldValue('location');
    payload.client = this.props.form.getFieldValue('client');
    await this.props.onCheck(payload);
  }

  handleScanInIphone = async data => {
    if (data) {
      const assetCode = data.split('assetCode=').pop().split('&')[0];
      let { subData } = this.state;
      subData = [{ assetCode: assetCode }];
      this.setState({ subData, loading: false }, () => {
        this.props.form.setFieldsValue({ [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: assetCode });
      });
    } else {
      this.setState({ loading: false });
      message.error('Please Try again');
    }
  };

  handlePasteInPhone = async data => {
    if (data) {
      const assetCode = data;
      let { subData } = this.state;
      subData = [{ assetCode: assetCode }];
      this.setState({ subData, loading: false }, () => {
        this.props.form.setFieldsValue({ [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: assetCode });
      });
    } else {
      this.setState({ loading: false });
      message.error('Please Try again');
    }
  };

  resetSubData = () => {
    this.setState({
      subData: [{}]
    })
  }

  resetScannedAssetData = () => {
    // console.log('resetting scanned data');
    this.setState({
      scannedOrManualAsset: null
    })
  }

  onLoad = (data) => {
    this.setState({ loading: true });
  };

  handleError = err => {
    console.error(err)
  };

  openCamera = () => {
    this.setState({ openCamera: !this.state.openCamera })
  };

  renderCamera = () => {
    this.qrCode.current.openImageDialog();
  }

  handleDisableQRCode = (data) => {
    this.setState({ disableQRCode: data });
  }

  mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
    const merged = [...(baseOptions || [])];
    (createdOptions || []).forEach((created) => {
      if (!created || !created._id) {
        return;
      }
      const exists = merged.find((option) => `${option && option._id}` === `${created._id}`);
      if (!exists) {
        merged.push(created);
      }
    });
    return merged;
  }

  getAuditVoucherOptions = () => {
    const { filters } = this.props;
    const baseOptions = filters && filters.auditVoucher && filters.auditVoucher.data && filters.auditVoucher.data.data || [];
    return this.mergeUniqueOptions(baseOptions, this.state.createdAuditVouchers);
  }

  // When a voucher carries an audit scope, drive the form's location /
  // sub-location from it. Those fields are then disabled in render (derived from
  // the selected voucher), so the audit always opens against the voucher's scope.
  handleAuditVoucherSelect = (voucherId) => {
    const voucher = (this.getAuditVoucherOptions() || []).find(o => `${o && o._id}` === `${voucherId}`);
    const idOf = (v) => (v && (v._id || v)) || undefined;
    const locationId = voucher && idOf(voucher.location);
    const clientId = voucher && idOf(voucher.client);

    const next = {};
    if (locationId) next.location = locationId;
    if (clientId) next.client = clientId;
    if (Object.keys(next).length) {
      this.props.form.setFieldsValue(next);
    }

    // Auto-fill bypasses the manual onSelect handlers, so keep the duplicate-report
    // check working for roles that require it.
    if (this.state.disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation && locationId) {
      payload.location = locationId;
      payload.client = clientId;
      this.props.onCheck(payload);
    }
  }

  handleAuditVoucherCreated = (createdAuditVoucher) => {
    if (!createdAuditVoucher || !createdAuditVoucher._id) {
      return;
    }
    this.setState((prevState) => {
      const exists = (prevState.createdAuditVouchers || []).find((item) => `${item._id}` === `${createdAuditVoucher._id}`);
      if (exists) {
        return null;
      }
      return {
        createdAuditVouchers: [...(prevState.createdAuditVouchers || []), createdAuditVoucher],
      };
    });
    this.props.form.setFieldsValue({
      auditVoucher: createdAuditVoucher._id,
    });
  }

  componentWillUnmount() {
    this.props.clearData();
    cnt = 0;
    payload = {};
  }

  setManualQr = (qr) => {
    // this.setState({
    //     scannedOrManualQrId: qr
    // })
  }

  render() {
    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form, authUser } = this.props;
    const {
      subData,
      formData,
      openCamera,
      disableQRCode,
      disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation
    } = this.state;
    const auditVoucherOptions = this.getAuditVoucherOptions();

    // Lock location / sub-location when the selected voucher defines that scope.
    const idOf = (v) => (v && (v._id || v)) || undefined;
    const selectedVoucherId = getFieldValue('auditVoucher') || (data && idOf(data['auditVoucher']));
    const selectedVoucher = (auditVoucherOptions || []).find(o => `${o && o._id}` === `${selectedVoucherId}`);
    const lockLocation = !!(selectedVoucher && idOf(selectedVoucher.location));
    const lockClient = !!(selectedVoucher && idOf(selectedVoucher.client));
    return (
      <Spin spinning={this.state.loading || loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <div className={'asset-stock-taking'}>

              <Form.Item key={'auditVoucher'} label={sanitizeFieldName('auditVoucher')}>
                {getFieldDecorator('auditVoucher', {
                  rules: [{ required: true, message: `${sanitizeFieldName('auditVoucher')} is required!` }],
                  initialValue: data && data['auditVoucher'] && (data['auditVoucher']._id || data['auditVoucher']),
                })(<Select
                  showSearch
                  style={{ width: '80%' }}
                  placeholder="Please select"
                  onChange={this.handleAuditVoucherSelect}
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                // disabled={(title === 'EDIT' && filters['auditVoucher'] && filters['auditVoucher'].options.disabledOnEdit) || false}
                >
                  {(auditVoucherOptions || []).map(itm =>
                    <Select.Option key={itm._id} value={itm._id}>{itm.voucherNo}</Select.Option>)}
                </Select>)}
                {
                  filters['auditVoucher'] && filters['auditVoucher'].options && filters['auditVoucher'].options.master ?
                    <InlineCreateMasterModal
                      item={filters['auditVoucher'].options.ref || 'AuditVoucher'}
                      onCreated={this.handleAuditVoucherCreated}
                      triggerStyle={{
                        margin: '0',
                        marginTop: '0',
                        marginLeft: '10px',
                        width: 'calc(100% - 10px)'
                      }}
                    /> : ''
                }
              </Form.Item>

              <Form.Item key={'location'} label={sanitizeFieldName('location')}>
                {getFieldDecorator('location', {
                  rules: [{ required: true, message: `${sanitizeFieldName('location')} is required!` }],
                  initialValue: data && data['location'] && (data['location']._id || data['location']),
                })(<Select
                  showSearch
                  style={{ width: '98%' }}
                  placeholder="Please select"
                  onSelect={disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation ? this.selectedLocation : ''}
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  disabled={lockLocation || (title === 'EDIT' && filters['location'] && filters['location'].options.disabledOnEdit) || false}
                >
                  {filters['location'] && filters['location']['data'] && filters['location']['data']['data'].map(itm =>
                    <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                </Select>)}
                {
                  filters['location'] && filters['location'].options && filters['location'].options.master ?
                    <MasterModal resource={resource} item={filters['location'].options.ref}
                      title={'CREATE'} /> : ''
                }
              </Form.Item>
              <Form.Item key={'client'}
                label={sanitizeFieldName(filters['client'] && filters['client'].options.label ? filters['client'].options.label : 'client')}>
                {getFieldDecorator('client', {
                  rules: [{
                    required: false,
                    message: `${sanitizeFieldName(filters['client'] && filters['client'].options.label ? filters['client'].options.label : 'client')} is required!`
                  }],
                  initialValue: data && data['client'] && (data['client']._id || data['client']),
                })(<Select
                  showSearch
                  style={{ width: '98%' }}
                  onSelect={disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation ? this.selectedSubLocation : ''}
                  placeholder="Please select"
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  disabled={lockClient || (title === 'EDIT' && filters['client'] && filters['client'].options.disabledOnEdit) || false}
                >
                  {filters['client'] && filters['client']['data'] && filters['client']['data']['data'].map(itm =>
                    <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                </Select>)}
                {
                  filters['client'] && filters['client'].options && filters['client'].options.master ?
                    <MasterModal resource={resource} item={filters['client'].options.ref}
                      title={'CREATE'} /> : ''
                }
              </Form.Item>

              {
                openCamera ?
                  <QrScan handleScan={this.handleScan}
                    isOnlyRead
                    setOldQr={this.setOldQr}
                    getAssetByQr={this.props.getAssetByQr}
                    renderCamera={this.renderCamera}
                    openCamera={openCamera} toggleOpenCamera={this.openCamera}
                    onLoad={this.onLoad}
                    checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
                    disableQRCode={this.state.disableQRCode} qrCodeRef={this.qrCode} />
                  : null
              }

              <Button type="primary" disabled={disableQRCode} onClick={this.openCamera}
                className="gx-mb-0">Scan QR Code</Button>

              {/*<div>*/}
              {/*  <Modal*/}
              {/*    title="Scan QR Code"*/}
              {/*    visible={openCamera}*/}
              {/*    onCancel={this.openCamera}*/}
              {/*    centered*/}
              {/*    footer={<Button onClick={this.openCamera}>Close</Button>}*/}
              {/*  >*/}
              {/*    {*/}
              {/*      openCamera && <QrReader*/}
              {/*        delay={300}*/}
              {/*        onError={this.handleError}*/}
              {/*        onScan={this.handleScan.bind(this)}*/}
              {/*        style={{width: '100%', margin: '0 auto'}}*/}
              {/*        facingMode={'environment'}*/}
              {/*        onImageLoad={this.onLoad}*/}
              {/*      />*/}
              {/*      // openCamera && <Scanner/>*/}
              {/*    }*/}
              {/*  </Modal>*/}

              {/*  <QrReader*/}
              {/*    legacyMode*/}
              {/*    ref={this.qrCode}*/}
              {/*    delay={300}*/}
              {/*    onError={this.handleError}*/}
              {/*    onScan={this.handleScanInIphone.bind(this)}*/}
              {/*    style={{display: 'none'}}*/}
              {/*    facingMode={'environment'}*/}
              {/*    onImageLoad={this.onLoad}*/}
              {/*  />*/}
              {/*  {*/}
              {/*    (isIOS && isChrome) ?*/}
              {/*      <Button type="primary" disabled={disableQRCode} onClick={this.renderCamera} className="gx-mb-0">Scan*/}
              {/*        QR Code</Button> :*/}
              {/*      <Button type="primary" disabled={disableQRCode} onClick={this.openCamera} className="gx-mb-0">Scan*/}
              {/*        QR Code</Button>*/}
              {/*  }*/}
              {/*</div>*/}

              {Object.keys(filters).map((item, index) => {


                if (filters[item].type === 'Array' && filters[item].schema) {
                  if (filters[item].field === 'assetDetails') {
                    return (title === 'VIEW') ?
                      <SubList ref={this.child} key={item} item={filters[item]} form={form}
                        data={undefined}
                        title={title} resource={resource}
                        subDocumentFilters={subDocumentFilters}
                        match={this.props.match} history={this.props.history}
                        isOldQr={this.state.isOldQr} /> :
                      <SubListForm ref={this.child} key={item}
                        handleDisableQRCode={this.handleDisableQRCode}
                        item={filters[item]} form={form} data={undefined} title={title}
                        resource={resource}
                        subDocumentFilters={subDocumentFilters}
                        match={this.props.match}
                        history={this.props.history} onPaste={this.handlePasteInPhone}
                        isOldQr={this.state.isOldQr}
                        getAssetByQr={this.props.getAssetByQr}
                        assetFromQr={this.props.assetFromQr}
                        getAssetByCode={this.props.getAssetByCode}
                        assetFromCode={this.props.assetFromCode}
                        setManualQr={this.setManualQr} width={this.props.width}
                        assetData={this.state.subData} resetSubData={this.resetSubData}
                        scannedAssetData={this.state.scannedOrManualAsset}
                        resetScannedAssetData={this.resetScannedAssetData}
                        loading={this.props.loading}
                        qrUsed={this.props.qrUsed}
                        checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
                        createLink={this.props.createLink}
                        linkStatus={this.props.linkStatus}
                        allTagTypes={this.props.allTagTypes}
                        getAllTagTypes={this.props.getAllTagTypes}
                        linkRecordCode={this.state.linkRecordCode}
                      />
                  }
                } else {
                  if (item !== 'client' && item !== 'location' && item !== 'user' && item !== 'auditVoucher') {
                    return getFormFieldByType(filters, item, getFieldDecorator, formData, {
                      resource,
                      title,
                      setFieldsValue
                    })
                  }
                }
              })}
            </div>
            {
              title !== 'CREATE' && <Form.Item key={'user'} label={'Opened By'}>
                {getFieldDecorator('user', {
                  rules: [{ required: true, message: `Opened By is required!` }],
                  initialValue: data && data['user'] && (data['user']._id || data['user']),
                })(<Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Please select"
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  disabled={(title === 'EDIT' && filters['user'] && filters['user'].options.disabledOnEdit) || false}
                >
                  {filters['user'] && filters['user']['data'] && filters['user']['data']['data'].map(itm =>
                    <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
                </Select>)}
              </Form.Item>
            }

            <Form.Item>
              {
                this.props.warning.code === 201 && disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation ?
                  <Popconfirm placement="topRight"
                    title={this.props.warning.message}
                    onConfirm={(id) => {
                      this.editEarlier(this.props.warning.id)
                    }}
                    onCancel={() => this.props.history.push(`/asset-stock-taking`)} //{this.handleSubmit}
                    okText="Edit Earlier Report"
                    cancelText="Exit"
                  > <Button type="primary" className="gx-mb-0"
                    disabled={data && data.status === 'COMPLETED'}
                    htmlType={'submit'}>
                      SAVE & NEXT
                    </Button>&nbsp;&nbsp;
                  </Popconfirm> :
                  <Button type="primary" className="gx-mb-0"
                    disabled={data && data.status === 'COMPLETED'}
                    htmlType={'submit'}>
                    SAVE & NEXT
                  </Button>
              }

              {
                this.props.warning.code === 201 && disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation ?
                  <Popconfirm placement="topRight"
                    title={this.props.warning.message}
                    onConfirm={(id) => {
                      this.editEarlier(this.props.warning.id)
                    }}
                    onCancel={() => this.props.history.push(`/asset-stock-taking`)} //{this.handleSubmit}
                    okText="Edit Earlier Report"
                    cancelText="Exit"
                  > <Button type="primary" className="gx-mb-0"
                    disabled={data && data.status === 'COMPLETED'}>
                      SAVE & EXIT
                    </Button>&nbsp;&nbsp;
                  </Popconfirm> :
                  <Button type="primary" className="gx-mb-0"
                    disabled={data && data.status === 'COMPLETED'}
                    onClick={this.handleDone}>
                    SAVE & EXIT
                  </Button>
              }
              <Button type="primary" className="gx-mb-0" disabled={data && !data._id}
                onClick={() => this.props.history.push(`/asset-stock-taking/view/${data && data._id}`)}>
                EXIT
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default geolocated()(CreateForm);
